<template>
	<div class="login-view" :class="configStore.electronMode ? 'white-backgroup' : ''">
		<div class="content">
			<el-form class="form" :model="loginForm" status-icon :rules="rules" ref="loginForm"
				@keyup.enter.native="submitForm()" v-loading="loading" element-loading-text="正在登陆...">
				<div class="back-arrow" @click="goBack">
					<img src="../assets/image/back.png" alt="" style="width: 16px; height: 16px;"> 返回
				</div>
				<span class="member">企业号 : {{ Enumber }}</span>
				<div class="title">
					<div>登录{{ appNameZh }}</div>
				</div>
				<el-form-item prop="userName" v-show="false">
					<el-input type="terminal" v-model="loginForm.terminal" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item prop="userName" style="margin: 30px 0px;">
					<el-input type="userName" v-model="loginForm.userName" autocomplete="off"
						:placeholder="loginNamePlaceholder" prefix-icon="el-icon-user"></el-input>
				</el-form-item>
				<el-form-item prop="password" style="margin: 30px 0px;">
					<el-input type="password" v-model="loginForm.password" autocomplete="off" placeholder="密码"
						prefix-icon="el-icon-lock" show-password></el-input>
				</el-form-item>
				<el-form-item style="margin: 30px 0px;">
					<el-checkbox v-model="isAutoLogin">下次自动登录</el-checkbox>
				</el-form-item>
				<el-button class="submit-btn" type="primary" @click="submitForm()">登录</el-button>
				<div class="register">
					<!-- <router-link to="/register">没有账号? 立即注册</router-link> -->
					<span class="to-register" v-if="enableRegister" @click="goRegister">
						没有账号? 立即注册
					</span>
				</div>
			</el-form>
		</div>
		<!-- <icp></icp> -->
		<captcha-image ref="captchaRef"></captcha-image>

	</div>
</template>

<script>
	import Icp from '../components/common/Icp.vue'
	import CaptchaImage from '../components/common/CaptchaImage.vue';
	import UAParser from 'ua-parser-js';

	export default {
		name: "login",
		components: {
			Icp,
			CaptchaImage
		},
		data() {
			var checkUsername = (rule, value, callback) => {
				if (!value) {
					return callback(new Error('请输入用户名'));
				}
				callback();
			};
			var checkPassword = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入密码'));
				}
				callback();
			};
			return {
				appNameZh: process.env.VUE_APP_ZH_NAME,
				loading: false,
				isAutoLogin: true,
				enableRegister: false,
				loginForm: {
					terminal: this.$enums.TERMINAL_TYPE.WEB,
					userName: '',
					password: '',
					clientOs: ''
				},
				Enumber: null,
				rules: {
					userName: [{
						validator: checkUsername,
						trigger: 'blur'
					}],
					password: [{
						validator: checkPassword,
						trigger: 'blur'
					}]
				}
			};
		},
		methods: {
			async loadConfig() {
				await this.adminConfigStore.loadAdminConfig();

				// 获取所有注册相关的配置
				const [min, emailReg, phoneReg, userNameReg] = await Promise.all([
					this.adminConfigStore.getConfigValueByKey('im.user.minimum.length'),
					this.adminConfigStore.getConfigValueByKey('im.email.registration'),
					this.adminConfigStore.getConfigValueByKey('im.phone.registration'),
					this.adminConfigStore.getConfigValueByKey('im.userName.registration')
				]);

				// 判断是否有启用的注册方式
				const isRegistrationEnabled = emailReg === 'true' || phoneReg === 'true' || userNameReg === 'true';

				// 根据判断结果设置 enableRegister
				this.enableRegister = isRegistrationEnabled;
			},
			goBack() {
				this.$router.push({
					path: '/Enterprise_number'
				});
			},
			goRegister() {
				const channelCode = localStorage.getItem('channelCode');
				if (channelCode) {
					this.$http({
						url: `/channel/select/${channelCode}`,
						method: 'GET'
					}).then(res => {
						if (Number(res.status) === 0) {
							this.$router.push({
								path: '/register'
							});
						} else {
							this.$message.error("无效渠道码，请检查后重试!");
						}
					})
				} else {
					this.$router.push({
						path: '/register'
					});
				}

			},
			submitForm() {
				this.$refs.loginForm.validate((valid) => {
					const parser = new UAParser();
					const os = parser.getOS();
					const cpu = parser.getCPU();
					this.loginForm.clientOs = os.name + " " + os.version + " " + cpu.architecture;
					if (valid) {
						this.loading = true;
						this.$http({
							url: "/login",
							method: 'post',
							data: this.loginForm
						}).then((data) => {
							localStorage.setItem('isAutoLogin', this.isAutoLogin);
							// 保存密码到
							localStorage.setItem('username', this.loginForm.userName);
							localStorage.setItem('password', this.loginForm.password);
							// localStorage
							sessionStorage.setItem("accessToken", data.accessToken);
							sessionStorage.setItem("refreshToken", data.refreshToken);
							this.$message.success("登录成功");
							this.$router.push("/home/chat");
						}).finally(() => {
							this.loading = false
						})
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			},
			// 获取cookie、
			getCookie(name) {
				let reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
				let arr = document.cookie.match(reg)
				if (arr) {
					return unescape(arr[2]);
				}
				return '';
			},
			// 设置cookie,增加到vue实例方便全局调用
			setCookie(name, value) {
				document.cookie = name + "=" + escape(value);
			}
		},
		mounted() {
			// 账号密码
			this.loginForm.userName = localStorage.getItem("username");
			this.loginForm.password = localStorage.getItem("password");
			this.loadConfig();
			// 加载配置
			this.configStore.loadConfig();
			// electron 窗口大小
			window.electronAPI && window.electronAPI.sendEvent('resize', {
				width: 360,
				height: 510,
				maximizable: false
			})
			window.electronAPI && window.electronAPI.sendEvent('center');
			// 自动登录
			if (localStorage.getItem("isAutoLogin") != null) {
				this.isAutoLogin = JSON.parse(localStorage.getItem("isAutoLogin"));
				if (this.isAutoLogin) {
					this.submitForm();
				}
			}
		},
		computed: {
			loginNamePlaceholder() {
				let mode = this.configStore.registration.mode;
				let strText = "用户名";
				if (mode.includes("phone")) {
					strText += "/手机号"
				}
				if (mode.includes("email")) {
					strText += "/邮箱"
				}
				return strText;
			}
		},
		created() {
			let tenantId = localStorage.getItem("tenantId");
			try {
				const parsed = JSON.parse(tenantId)
				if (parsed && typeof parsed === 'object') {
					this.Enumber = Number(parsed.data)
				} else {
					this.Enumber = isNaN(Number(tenantId)) ? String(tenantId) : Number(tenantId)
				}
			} catch (e) {
				this.Enumber = isNaN(Number(tenantId)) ? String(tenantId) : Number(tenantId)
			}
		}
	}
</script>

<style scoped lang="scss">
	.back-arrow {
		font-size: 14px;
		cursor: pointer;
		display: flex;
		align-items: center;
		margin-bottom: 20px;
	}

	.login-view {
		width: 100%;
		height: 100%;
		background: #E8F2FF;
		background-size: cover;
		box-sizing: border-box;
		display: flex;

		&.white-backgroup {
			background: white;
		}

		.content {
			position: relative;
			display: flex;
			justify-content: center;
			align-items: center;
			width: 100%;

			.form {
				width: 360px;
				height: 480px;
				padding: 30px;
				background: white;
				opacity: 0.9;
				box-shadow: 0px 0px 1px #ccc;
				border-radius: 3%;
				overflow: hidden;
				border: 1px solid #ccc;

				.member {
					font-style: italic;
					color: rgba(0, 0, 0, 0.5);
				}

				.title {
					display: flex;
					justify-content: center;
					align-items: center;
					line-height: 50px;
					margin: 30px 0;
					font-size: 22px;
					font-weight: 600;
					letter-spacing: 2px;
					text-transform: uppercase;
					text-align: center;
				}

				.submit-btn {
					margin-top: 20px;
					width: 100%;
					height: 45px;
				}

				.register {
					display: flex;
					flex-direction: row-reverse;
					line-height: 40px;
					text-align: left;
					margin-top: 30px;
					margin-bottom: 20px;
					padding-left: 20px;
				}

				.to-register {
					cursor: pointer;
					color: #409eff;
				}
			}
		}
	}
</style>